import { bl_del_job_shipment_link_RowClass } from '../../../../dbschema';
import { BaseContainerModel } from '../../../base-container.model';

export class JobShipmentLinkContainerModel extends BaseContainerModel {
  bl_del_job_shipment_link: bl_del_job_shipment_link_RowClass= new bl_del_job_shipment_link_RowClass();
}